export const PhilosophySection = () => {
  return <section id="approach" className="relative py-16 sm:py-32 overflow-hidden bg-gradient-depth">
      {/* Clean minimalist background without photo */}
      
      {/* Layered background elements - Mobile Responsive */}
      <div className="absolute top-10 sm:top-20 left-10 sm:left-20 w-40 h-40 sm:w-80 sm:h-80 rounded-full opacity-10 sm:opacity-15 blur-3xl floating-element" style={{
      background: 'radial-gradient(circle, hsl(210 65% 32% / 0.3) 0%, transparent 70%)'
    }}></div>
      <div className="absolute bottom-16 sm:bottom-32 right-16 sm:right-32 w-48 h-48 sm:w-96 sm:h-96 rounded-full opacity-8 sm:opacity-10 blur-2xl floating-element" style={{
      background: 'radial-gradient(ellipse, hsl(210 65% 32% / 0.2) 0%, transparent 70%)',
      animationDelay: '2s'
    }}></div>
      
      <div className="container mx-auto px-4 sm:px-8 relative z-10">
        {/* Philosophy Content - Mobile Optimized */}
        <div className="max-w-6xl mx-auto">
          
          {/* Main Philosophy */}
          <div className="text-center mb-12 sm:mb-20 animate-fade-in relative">
            {/* Decorative elements */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-4 sm:-translate-y-8 w-16 sm:w-24 h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-40"></div>
            
            <h2 className="text-4xl sm:text-5xl font-display font-extralight bg-gradient-to-br from-foreground via-foreground to-primary bg-clip-text text-transparent mb-8 sm:mb-10 leading-[0.9] px-4 sm:px-0">
              Drei Prinzipien,
              <span className="block font-story italic" style={{
              color: 'hsl(210 65% 32%)'
            }}>
                die uns leiten
              </span>
            </h2>
            
            {/* Subtle grid accent */}
            <div className="absolute inset-0 opacity-[0.005] sm:opacity-[0.01] pointer-events-none" style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, hsl(210 65% 32%) 1px, transparent 0)`,
            backgroundSize: '40px 40px'
          }}></div>
          </div>

          {/* Enhanced Flowing Principles - Mobile Stacked */}
          <div className="space-y-12 sm:space-y-24">
            
            {/* Principle 1 - Mobile Optimized */}
            <div className="grid lg:grid-cols-3 gap-8 sm:gap-16 items-center animate-slide-up relative">
              {/* Background accent - hidden on mobile */}
              <div className="hidden lg:block absolute -left-16 top-0 w-64 h-full bg-gradient-accent-subtle opacity-30 rounded-3xl transform -skew-y-2"></div>
              
              <div className="lg:col-span-2 relative z-10">
                <div className="space-y-4 sm:space-y-6">
                  <div className="flex items-center space-x-3 sm:space-x-4">
                    <span className="text-4xl sm:text-6xl font-display font-extralight" style={{
                    color: 'hsl(210 65% 32%)'
                  }}>01</span>
                    <div className="flex-1 h-px bg-gradient-to-r from-primary via-primary/50 to-transparent"></div>
                    <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
                    backgroundColor: 'hsl(210 65% 32% / 0.6)'
                  }}></div>
                  </div>
                  <h3 className="text-xl sm:text-3xl font-display font-light text-foreground leading-tight">
                    Vertrauen durch Transparenz
                  </h3>
                  <div className="pl-3 sm:pl-4 border-l-2 border-primary/20">
                    <p className="text-base sm:text-lg text-muted-foreground leading-relaxed font-light">Wir glauben an offene Kommunikation und ein gutes Miteinander. Jeder Kandidat und jedes Unternehmen verdient absolute Ehrlichkeit über Chancen, Herausforderungen und Erwartungen.</p>
                  </div>
                </div>
              </div>
              <div className="hidden lg:block relative">
                <div className="w-32 h-32 sm:w-48 sm:h-48 rounded-full opacity-20 floating-element shadow-organic" style={{
                background: 'radial-gradient(circle, hsl(210 65% 32% / 0.2) 0%, transparent 70%)'
              }}></div>
              </div>
            </div>

            {/* Principle 2 - Mobile Optimized */}
            <div className="grid lg:grid-cols-3 gap-8 sm:gap-16 items-center animate-slide-up relative">
              {/* Background accent - right side, hidden on mobile */}
              <div className="hidden lg:block absolute -right-16 top-0 w-64 h-full bg-gradient-layered opacity-20 rounded-3xl transform skew-y-2"></div>
              
              <div className="hidden lg:block relative z-10">
                <div className="w-48 h-24 sm:w-64 sm:h-32 rounded-full blur-xl opacity-60 floating-element" style={{
                background: 'linear-gradient(45deg, hsl(210 65% 32% / 0.1) 0%, hsl(210 65% 32% / 0.05) 100%)',
                animationDelay: '0.5s'
              }}></div>
              </div>
              <div className="lg:col-span-2 relative z-10">
                <div className="space-y-4 sm:space-y-6 lg:text-right">
                  <div className="flex items-center space-x-3 sm:space-x-4 lg:flex-row-reverse">
                    <span className="text-4xl sm:text-6xl font-display font-extralight" style={{
                    color: 'hsl(210 65% 32%)'
                  }}>02</span>
                    <div className="flex-1 h-px bg-gradient-to-l from-primary via-primary/50 to-transparent lg:bg-gradient-to-r"></div>
                    <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
                    backgroundColor: 'hsl(210 65% 32% / 0.6)'
                  }}></div>
                  </div>
                  <h3 className="text-xl sm:text-3xl font-display font-light text-foreground leading-tight">
                    Qualität vor Quantität
                  </h3>
                  <div className="pl-3 sm:pl-4 lg:pr-4 border-l-2 lg:border-l-0 lg:border-r-2 border-primary/20 lg:ml-auto lg:max-w-2xl">
                    <p className="text-base sm:text-lg text-muted-foreground leading-relaxed font-light">
                      Wir arbeiten bewusst mit wenigen, dafür ausgewählten Mandaten. 
                      Jede Suche erhält unsere volle Aufmerksamkeit und wird mit der 
                      Sorgfalt behandelt, die außergewöhnliche Positionen verdienen.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Principle 3 - Mobile Optimized */}
            <div className="text-center animate-slide-up relative">
              {/* Circular accent background */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 sm:w-96 sm:h-96 rounded-full opacity-[0.02] sm:opacity-[0.03] pointer-events-none" style={{
              background: 'radial-gradient(circle, hsl(210 65% 32%) 0%, transparent 70%)'
            }}></div>
              
              <div className="max-w-4xl mx-auto space-y-6 sm:space-y-8 relative z-10 px-4 sm:px-0">
                <div className="flex items-center justify-center space-x-4 sm:space-x-6">
                  <div className="flex-1 h-px bg-gradient-to-r from-transparent via-primary to-primary/50"></div>
                  <span className="text-4xl sm:text-6xl font-display font-extralight" style={{
                  color: 'hsl(210 65% 32%)'
                }}>03</span>
                  <div className="flex-1 h-px bg-gradient-to-l from-transparent via-primary to-primary/50"></div>
                </div>
                <h3 className="text-xl sm:text-3xl font-display font-light text-foreground leading-tight">
                  Beziehungen, die überdauern
                </h3>
                <div className="max-w-3xl mx-auto">
                  <div className="px-4 sm:px-6 py-4 rounded-2xl bg-gradient-accent-subtle/50 backdrop-blur-sm">
                    <p className="text-base sm:text-lg text-muted-foreground leading-relaxed font-light">
                      Unsere Zusammenarbeit endet nicht mit der Vertragsunterzeichnung. 
                      Wir begleiten den Integrationsprozess und bleiben langfristiger Partner 
                      für alle zukünftigen Personalfragen.
                    </p>
                  </div>
                </div>
                
                {/* Enhanced Call to Action */}
                
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
};